<div class="content-container" [class.content-open]="minigamesOpen">
    @if (loaderVisible) {
        <ms-loading-indicator [delay]="loaderDelay" />
    }
    <iframe #casinoIframe class="mini-games-iframe" [src]="minigamesUrl | msTrust: 'resourceurl'"></iframe>
</div>
